<template>
  <material-card
    :title="title"
    data-testId="material-card-title"
    color="dover-blue">
    <v-form
      ref="form"
      v-model="isValidationOk"
      lazy-validation>
      <v-container
        py-0>
        <v-layout
          wrap>
          <v-flex
            xs12
            md6>
            <v-text-field
              v-model.trim="smtp.server"
              :rules="rules.required"
              :label="`${ $t('Server') }`"
              data-testId="text-field-Server"
              class="dover-input"/>
          </v-flex>
          <v-flex
            xs12
            md6>
            <v-text-field
              v-model.trim="smtp.emailSender"
              :rules="rules.required.concat(rules.email)"
              :label="`${ $t('Sender') }`"
              data-testId="text-field-Sender"
              class="dover-input"/>
          </v-flex>
          <v-flex
            xs12
            md6>
            <v-text-field
              v-model.trim="smtp.user"
              :label="`${ $t('User') }`"
              data-testId="text-field-User"
              counter
              class="dover-input"/>
          </v-flex>
          <v-flex
            xs12
            md6>
            <MaglinkComponentPassword
              :label="`${ $t('Password') }`"
              :initial-value="smtp.password"
              :rules="rules.required"
              data-testId="MaglinkComponentPassword-Password"
              comp-key="login"
              @onPasswordChange="onPasswordChange" />
          </v-flex>
          <v-flex
            xs12
            md6>
            <v-text-field
              v-model.number="smtp.port"
              :rules="rules.required.concat(rules.port)"
              :counter="5"
              :label="`${ $t('Port') }`"
              data-testId="text-field-Port"
              mask="#####"
              class="dover-input"/>
          </v-flex>
          <v-flex
            xs12
            md6>
            <v-switch
              v-model="smtp.enableSSL"
              :label="`${ $t('Enable SSL') }`"
              data-testId="switch-Enable-SSL"
              class="dover-input"/>
          </v-flex>
          <v-flex
            xs6
            md6
            text-xs-right>
            <v-btn
              :disabled="!isValidationOk || !Maglink.IsAdminUser()"
              data-testId="btn-Test"
              small
              class="mx-0 font-weight-light"
              color="dover-blue"
              @click="testEmail">
              {{ $t('Test') }}
            </v-btn>
          </v-flex>
          <v-flex
            xs6
            md6
            text-xs-right>
            <v-btn
              :disabled="!isValidationOk || !Maglink.IsAdminUser()"
              data-testId="btn-Save"
              small
              class="mx-0 font-weight-light"
              color="dover-blue"
              @click="save">
              {{ $t('Save') }}
            </v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </v-form>
  </material-card>
</template>

<script>
import Vue from 'vue'

export default {
  props: {
    title: {
      type: String,
      required: true
    }
  },
  data: () => ({
    isValidationOk: false,
    rules: {
      required: [ v => Vue.prototype.Maglink.RulesRequired(v) ],
      port: [ v => Vue.prototype.Maglink.RulesRange(v, 1, 65535) ],
      email: [ v => Vue.prototype.Maglink.RulesEmail(v) ],
      ipAddress: [ v => Vue.prototype.Maglink.RulesIP(v) ]
    },
    smtp: {}
  }),
  mounted () {
    this.Maglink.GetSettings('SMTPSettings')
      .then(response => {
        this.smtp = { ...this.smtp, ...response.data }
      })
      .catch(error => (this.snack('error', error.message)))
  },
  methods: {
    onPasswordChange (newPassword, compKey) {
      this.smtp.password = newPassword
    },
    save (event) {
      if (this.$refs.form.validate()) {
        this.isValidationOk = true

        this.Maglink.SetSettings('SMTPSettings', this.smtp)
          .then(response => (this.snack('success', response.data['done'])))
          .catch(error => (this.snack('error', error.message)))

        this.$emit('settingsSaved')
      } else {
        this.isValidationOk = false
      }
    },
    testEmail () {
      if (this.$refs.form.validate()) {
        this.isValidationOk = true

        this.Maglink.SendTestEmail(this.smtp)
          .then(response => {
            let resp = response.data // {result, msg} result=0 --> ok;
            this.snack((resp.result === '0') ? 'success' : 'error', resp.msg)
          })
          .catch(error => {
            this.snack('error', error.message)
          })
      } else {
        this.isValidationOk = false
      }
    },
    snack (color, message) {
      message = this.title + ': ' + message
      this.$store.dispatch('showSnackbar', { color, message, show: true })
    }
  }
}
</script>
